(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9209],{

/***/ 438855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "WE": function() { return /* reexport */ CartButton/* default */.Z; },
  "rs": function() { return /* reexport */ AtomicComponents_Switch; }
});

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js + 1 modules
var Button = __webpack_require__(952479);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/index.js + 2 modules
var CartButton = __webpack_require__(891815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(452388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/Switch.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  cursor: pointer;\n  box-sizing: border-box;\n  outline: none;\n  width: ",
        ";\n  outline: none;\n  background-color: #eeeef1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 12px;\n\n  color: #646464;\n\n  width: ",
        ";\n  width: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    width: 100px;\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    width: 80px;\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  transform: translateY(-50%);\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 50%;\n  ",
        "\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 100%;\n  padding: 8px 12px;\n\n  border-top-left-radius: ",
        ";\n  border-bottom-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var SwitchContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchContainer",
    componentId: "sc-3f72cec7-0"
})(_templateObject(), function(props) {
    return props.fluid ? "100%" : "fit-content";
});
var switches = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "switches",
    componentId: "sc-3f72cec7-1"
})(_templateObject1(), function(props) {
    return props.fontSize || 14;
});
var SwitchLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchLabel",
    componentId: "sc-3f72cec7-2"
})(_templateObject2(), function(props) {
    return props.width && "".concat(props.width, " !important;");
}, function(props) {
    return props.fluid && "100% !important;";
});
var SwitchToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchToggle",
    componentId: "sc-3f72cec7-3"
})(_templateObject3(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return !!props.isToggle ? "right: -5px;" : "left: -5px;";
});
var Toggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Toggle",
    componentId: "sc-3f72cec7-4"
})(_templateObject4(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness * 2);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
});

// EXTERNAL MODULE: ./src/containers/Orders/context/index.tsx
var context = __webpack_require__(860227);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/index.js





var Switch = function(props) {
    var ref = (0,react.useContext)(context/* OrderContext */.y), onChangeActiveTab = ref.onChangeActiveTab, activeTab = ref.activeTab;
    var _tabsData = props.tabsData, tabsData = _tabsData === void 0 ? [] : _tabsData, _roundness = props.roundness, roundness = _roundness === void 0 ? 2 : _roundness, _fluid = props.fluid, fluid = _fluid === void 0 ? false : _fluid, backgroundColor = props.backgroundColor, width = props.width;
    var tabRoundness = (0,util/* roundnessCalculator */.M)(roundness) || "0px";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchContainer, {
        backgroundColor: backgroundColor,
        fluid: fluid,
        fontSize: 14,
        className: "tw-h-[48px]",
        style: {
            borderRadius: tabRoundness
        },
        children: tabsData.map(function(param) {
            var text = param.text, key = param.key;
            var isActiveTab = activeTab === key;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchLabel, {
                fluid: fluid,
                width: width,
                onClick: function() {
                    return onChangeActiveTab(key);
                },
                isActiveTab: isActiveTab,
                className: "tw-relative tw-h-full tw-w-full tw-bg-transparent",
                style: {
                    borderRadius: tabRoundness
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: isActiveTab ? "tw-absolute -tw-inset-x-[5px] -tw-inset-y-[2px] tw-z-10 tw-flex tw-items-center tw-justify-center tw-text-white" : "",
                    style: {
                        backgroundColor: isActiveTab ? backgroundColor : "transparent",
                        borderRadius: tabRoundness
                    },
                    children: text
                })
            }, key);
        })
    });
};
/* harmony default export */ var AtomicComponents_Switch = (Switch);

;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/index.js






/***/ }),

/***/ 860227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ OrderContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

var OrderContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 219209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_Orders; }
});

// UNUSED EXPORTS: INITIAL_PAGINATION_CONFIG

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(414924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(336623);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/getAuthToken.js
var getAuthToken = __webpack_require__(861305);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/containers/Orders/components/AuthenticateUserModal.tsx










var AuthModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6956), __webpack_require__.e(4814), __webpack_require__.e(1242), __webpack_require__.e(3973)]).then(__webpack_require__.bind(__webpack_require__, 493973));
});
var AuthenticateUserModal = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)({
        showAuthModel: false
    }), state = ref[0], setState = ref[1];
    var user = (0,es/* useSelector */.v9)(function(state) {
        return {
            user: state.userReducer
        };
    }).user;
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            collections: state.catalogReducer.collections
        };
    }), storeData = ref1.storeData, collections = ref1.collections;
    (0,react.useEffect)(function() {
        var authToken = (0,getAuthToken/* getAuthToken */.b)();
        if (authToken && (storeData === null || storeData === void 0 ? void 0 : storeData.store_id)) {
            dispatch((0,catalog/* getCustomerReviewSettings */.vV)(storeData.store_id));
        } else {
            localStorage.removeItem(constants/* AUTH_TOKEN */.UA);
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("deliveryType", "");
            setState({
                showAuthModel: true
            });
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id
    ]);
    var toggleAuthModal = function() {
        var ref, ref1;
        if (!(user === null || user === void 0 ? void 0 : user.isLogin)) {
            setState({
                showAuthModel: !state.showAuthModel
            });
            return;
        }
        if (!state.showAuthModel) {
            return;
        }
        router.push((0,routes.getRoute)((collections === null || collections === void 0 ? void 0 : collections.length) ? routes.PATH.PRODUCT : (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.custom_theme_flag) ? routes.PATH.PRODUCT : routes.PATH.SHOP, storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
        setState({
            showAuthModel: false
        });
    };
    if (!state.showAuthModel) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal, {
        toggleModal: toggleAuthModal,
        isVisible: state.showAuthModel
    });
};

// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(353978);
// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(698616);
// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(471778);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
;// CONCATENATED MODULE: ./src/containers/Orders/components/Headers.js









var MobileHeader = function(param) {
    var storeData = param.storeData;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: "mobile-header",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "header-top",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "back-icon",
                    loading: "lazy",
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/1cy3Zqf6.webp",
                    alt: "back",
                    onClick: function() {
                        router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeData.store_info.domain));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "header-title",
                    children: (0,getCustomCtaText/* default */.Z)("my_orders_cta")
                })
            ]
        })
    });
};
var DesktopHeader = function(param) {
    var storeData = param.storeData;
    var ref;
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    if (!isComponentMounted) {
        return null;
    }
    return (ref = (0,specificThemeRender/* specificThemeRender */.t)(storeData)) === null || ref === void 0 ? void 0 : ref.components.Header.map(function(layout) {
        return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
    });
};
var Header = function() {
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    if (checkClientDeviceType/* IS_MOBILE */.q$) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileHeader, {
            storeData: storeData
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopHeader, {
        storeData: storeData
    });
};

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(438855);
;// CONCATENATED MODULE: ./src/constants/order.js
var ORDERS_LIST_TYPE = {
    PENDING: "pending",
    COMPLETED: "completed",
    FAILED_PAYMENTS: "payment_failed"
};
var TABS_DATA = [
    {
        text: "Pending",
        key: ORDERS_LIST_TYPE.PENDING
    },
    {
        text: "Completed",
        key: ORDERS_LIST_TYPE.COMPLETED
    },
    {
        text: "Failed",
        key: ORDERS_LIST_TYPE.FAILED_PAYMENTS
    }, 
];
var TABS_DATA_MAP = TABS_DATA.reduce(function(result, tabsData) {
    result[tabsData.key] = tabsData;
    return result;
}, {});

;// CONCATENATED MODULE: ./src/containers/Orders/components/OrderHeaderView.js





function OrderHeaderView() {
    var ref;
    var theme = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        return (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : ref.theme;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            margin: "10px auto 15px",
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Switch */.rs, {
            tabsData: TABS_DATA,
            roundness: theme === null || theme === void 0 ? void 0 : theme.roundness,
            fluid: true,
            backgroundColor: theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color
        })
    });
}
/* harmony default export */ var components_OrderHeaderView = ((/* unused pure expression or super */ null && (OrderHeaderView)));

;// CONCATENATED MODULE: ./src/assets/svgExports/ZeroOrder.js



function ZeroOrder(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 222,
        height: props.height || 222,
        viewBox: "0 0 222 222"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: ".prefix__b{fill:#9b9b9b}"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                transform: "translate(-45.08 -204.08)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: 111,
                        cy: 111,
                        r: 111,
                        transform: "translate(45.08 204.08)",
                        fill: "#fbfbfb"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "prefix__b",
                        d: "M149.095 326.393l2.582-10.489 8.762 2.157-2.582 10.489z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "prefix__b",
                        d: "M171.937 252.318a35.546 35.546 0 1026.045 43.011 35.551 35.551 0 00-26.045-43.011zm-14.875 60.547a26.8 26.8 0 1132.412-19.627 26.79 26.79 0 01-32.409 19.627z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "prefix__b",
                        d: "M132.447 379.266c-.746 3.037 2.156 6.36 6.483 7.423 4.326 1.062 8.437-.537 9.184-3.573l12.27-49.949c.747-3.036-2.156-6.36-6.482-7.422-4.327-1.062-8.439.537-9.185 3.573z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M137.435 280.448a26.8 26.8 0 1119.63 32.417 26.8 26.8 0 01-19.63-32.417z",
                        style: {
                            mixBlendMode: "screen",
                            isolation: "isolate"
                        },
                        fill: "#fff",
                        opacity: 0.869
                    })
                ]
            })
        ]
    }));
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/containers/Orders/order.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: calc(100vh - 4rem);\n  width: 100%;\n  padding: 0 20px;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  max-width: 600px;\n  flex: 0.5;\n  margin: 0 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  width: 90%;\n\n  @media screen and (min-width: 767px) {\n    font-size: 20px;\n    padding: 40px 0;\n    margin: 0 auto;\n  }\n\n  @media screen and (max-width: 766px) {\n    padding: 30px 0;\n    margin: 0 auto;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  text-align: center;\n  font: normal normal normal 14px/18px Montserrat;\n  letter-spacing: 0.36px;\n  color: #777777;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var NoItemInOrder = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "NoItemInOrder",
    componentId: "sc-cc07887e-0"
})(_templateObject());
var NoItemInOrderSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NoItemInOrderSection",
    componentId: "sc-cc07887e-1"
})(_templateObject1());
var NoItemInOrderText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "NoItemInOrderText",
    componentId: "sc-cc07887e-2"
})(_templateObject2());
var NoFound = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "NoFound",
    componentId: "sc-cc07887e-3"
})(_templateObject3());

// EXTERNAL MODULE: ./src/redux/store/index.js + 44 modules
var store = __webpack_require__(167261);
// EXTERNAL MODULE: ./src/utils/getTotalCartAmounts.js
var getTotalCartAmounts = __webpack_require__(668246);
// EXTERNAL MODULE: ./src/utils/orderItemsToBuyAgain.js
var orderItemsToBuyAgain = __webpack_require__(122877);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(666162);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(586423);
;// CONCATENATED MODULE: ./src/containers/Orders/tools.ts











var handleNavigateReorder = function(e, configs) {
    e.stopPropagation();
    var rawOrderItems = configs.orderItems, cartItems = configs.cartItems, userData = configs.userData, storeData = configs.storeData, router = configs.router;
    var orderItems = (0,orderItemsToBuyAgain/* orderItemsToBuyAgain */.C)(rawOrderItems);
    var items = (0,_to_consumable_array/* default */.Z)(cartItems).concat((0,_to_consumable_array/* default */.Z)(orderItems));
    var amount_values = (0,getTotalCartAmounts/* getTotalCartAmounts */.a)(items);
    var payload = (0,_object_spread/* default */.Z)({
        items: items,
        store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        merchant_id: 1,
        order_type: 2,
        phone: (userData === null || userData === void 0 ? void 0 : userData.phone) || "",
        status: 1,
        status_message: "New",
        deliver_to: "",
        address1: "",
        address2: "",
        latitude: 0,
        longitude: 0
    }, amount_values);
    store/* default.dispatch */.Z.dispatch((0,cart/* saveCart */.FP)(payload));
    router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeData.store_info.domain));
};
var getNoItemInOrderText = function(orderListType) {
    var ref, ref1, ref2;
    var storeType = (0,getStoreType/* getStoreType */.K)();
    var storeTypeBasedtext = "";
    switch(storeType){
        case constants/* STORE_CUSTOMIZATION.ORDER_BASED */.DO.ORDER_BASED:
            storeTypeBasedtext = "order";
            break;
        case constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B:
            storeTypeBasedtext = "request";
            break;
        default:
            storeTypeBasedtext = "service";
    }
    return "You don't have any ".concat(TABS_DATA_MAP === null || TABS_DATA_MAP === void 0 ? void 0 : (ref = TABS_DATA_MAP[orderListType]) === null || ref === void 0 ? void 0 : (ref1 = ref.text) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.toLocaleLowerCase) === null || ref2 === void 0 ? void 0 : ref2.call(ref1), " ").concat(storeTypeBasedtext);
};
var shopButtonClick = function(param) {
    var collections = param.collections, router = param.router, storeData = param.storeData;
    if (collections === null || collections === void 0 ? void 0 : collections.length) {
        var ref;
        router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    } else {
        var ref1;
        if ((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.theme_class)) {
            var ref2, ref3, ref4;
            if (storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.custom_theme_flag) router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.store_info) === null || ref3 === void 0 ? void 0 : ref3.domain));
            else router.push((0,routes.getRoute)(routes.PATH.SHOP, storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.store_info) === null || ref4 === void 0 ? void 0 : ref4.domain));
        } else {
            var ref5;
            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : (ref5 = storeData.store_info) === null || ref5 === void 0 ? void 0 : ref5.domain));
        }
    }
};

// EXTERNAL MODULE: ./src/containers/Orders/context/index.tsx
var context = __webpack_require__(860227);
;// CONCATENATED MODULE: ./src/containers/Orders/components/NoItemView.js











var NoItemView = function() {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var activeTab = (0,react.useContext)(context/* OrderContext */.y).activeTab;
    var ref3 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            collections: state.catalogReducer.collections
        };
    }), storeData = ref3.storeData, collections = ref3.collections;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoItemInOrder, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoItemInOrderSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ZeroOrder, {
                        height: checkClientDeviceType/* IS_DESKTOP */.yn ? 222 : 162,
                        width: checkClientDeviceType/* IS_DESKTOP */.yn ? 222 : 162
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoItemInOrderText, {
                        children: getNoItemInOrderText(activeTab)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                px: checkClientDeviceType/* IS_DESKTOP */.yn ? "75px" : "26px",
                py: "18px",
                fontColor: "#ffffff",
                roundness: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.roundness,
                backgroundColor: storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color,
                label: (0,getCustomCtaText/* default */.Z)("banner_cta"),
                variant: "solid",
                onClick: function() {
                    return shopButtonClick({
                        collections: collections,
                        router: router,
                        storeData: storeData
                    });
                },
                fontSize: checkClientDeviceType/* IS_DESKTOP */.yn ? 20 : 18
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/FlatList/index.js
var FlatList = __webpack_require__(155772);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(730381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-rating-stars-component/dist/react-stars.js
var react_stars = __webpack_require__(511312);
// EXTERNAL MODULE: ./src/components/CustomerReviewModal/index.js + 4 modules
var CustomerReviewModal = __webpack_require__(88557);
// EXTERNAL MODULE: ./src/containers/Orders/components/OrderItem/ItemWithReview.module.scss
var ItemWithReview_module = __webpack_require__(317945);
var ItemWithReview_module_default = /*#__PURE__*/__webpack_require__.n(ItemWithReview_module);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/utils/productUtils.ts
var productUtils = __webpack_require__(236913);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
;// CONCATENATED MODULE: ./src/containers/Orders/components/OrderItem/ItemWithReview.js












var ItemWithReview = function(param) {
    var order = param.order, item = param.item, isComplete = param.isComplete;
    var ref, ref1;
    var loggedInUserReview = Array.isArray(item === null || item === void 0 ? void 0 : (ref = item.store_item_review_rating) === null || ref === void 0 ? void 0 : ref.review_rating) && (item === null || item === void 0 ? void 0 : (ref1 = item.store_item_review_rating) === null || ref1 === void 0 ? void 0 : ref1.review_rating[0]);
    var ref2 = (0,react.useState)(false), openReviewModal = ref2[0], setOpenReviewModal = ref2[1];
    var ref3 = (0,react.useState)(loggedInUserReview ? loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating : 0), rating = ref3[0], setRating = ref3[1];
    var ref4 = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeInfo: state.storeReducer.store,
            reviewSettings: state.catalogReducer.reviewSettings
        };
    }), storeInfo = ref4.storeInfo, reviewSettings = ref4.reviewSettings;
    var crrFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().crrFeatureStatus;
    var isCRRFeatureUnlocked = !(crrFeatureStatus === null || crrFeatureStatus === void 0 ? void 0 : crrFeatureStatus.isLocked);
    (0,react.useEffect)(function() {
        if (loggedInUserReview) setRating(loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating);
    }, [
        loggedInUserReview
    ]);
    var handleReviewModalOpen = function() {
        return setOpenReviewModal(true);
    };
    var handleReviewModalClose = function() {
        setOpenReviewModal(false);
        setRating(loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating);
    };
    var handleStopPropagation = function(e) {
        return e.stopPropagation();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ItemWithReview_module_default()).reviewItemContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-[16px]",
                        onClick: function(e) {
                            var ref;
                            e.stopPropagation();
                            router_default().push((0,routes.getRoute)((0,productUtils/* getProductPathFromUrl */.ts)(item === null || item === void 0 ? void 0 : item.link, false), storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item.thumbnail_url,
                                width: "64px",
                                height: "64px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mv0 f14px",
                                children: [
                                    item.item_name,
                                    " X ",
                                    item.quantity
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-column pv10px pl16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                            isComplete && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked && deviceWidth/* deviceWidth */.o > 766 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center pt10px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mv0 star-dust f12px",
                                        children: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating) ? "Your rating" : "Rate product"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pl8px flex items-center",
                                        onClick: handleStopPropagation,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-flex tw-cursor-pointer",
                                                onClick: handleReviewModalOpen,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                                    size: 21,
                                                    classNames: (ItemWithReview_module_default()).gap,
                                                    onChange: function(rating) {
                                                        setRating(rating);
                                                        handleReviewModalOpen();
                                                    },
                                                    value: rating,
                                                    count: 5
                                                }, "stars_".concat(rating))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ItemWithReview_module_default()).verticalLine
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (ItemWithReview_module_default()).writeReview,
                                                onClick: handleReviewModalOpen,
                                                children: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review) ? "Edit review" : "Write a Review"
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            isComplete && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked && deviceWidth/* deviceWidth */.o <= 766 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-column items-start pt10px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        onClick: handleStopPropagation,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mv0 star-dust",
                                children: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating) ? "Your rating" : "Rate product"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pl8px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                    size: 21,
                                    classNames: (ItemWithReview_module_default()).gap,
                                    onChange: function(rating) {
                                        setRating(rating);
                                        handleReviewModalOpen();
                                    },
                                    value: rating,
                                    count: 5
                                }, "stars_".concat(rating))
                            })
                        ]
                    }),
                    deviceWidth/* deviceWidth */.o > 766 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ItemWithReview_module_default()).verticalLine,
                        onClick: handleStopPropagation
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt16px mb8px",
                        onClick: handleStopPropagation,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ItemWithReview_module_default()).writeReview,
                            onClick: handleReviewModalOpen,
                            children: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review) ? "Edit review" : "Write a Review"
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: handleStopPropagation,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerReviewModal/* default */.Z, {
                    ratingFromProps: rating,
                    open: openReviewModal,
                    onClose: handleReviewModalClose,
                    product: item,
                    order_id: order.order_id,
                    loggedInUserReview: loggedInUserReview,
                    onSubmit: function() {
                        return !checkRenderEnv/* IS_SERVER */.W6 && window.location.reload();
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var OrderItem_ItemWithReview = (ItemWithReview);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/containers/Orders/components/OrderItem/index.js
/**
 * Order Item Component
 */ 







function getOrderMode(order) {
    return order === null || order === void 0 ? void 0 : order.order_mode;
}
var OrderItem = function(param) {
    var order = param.order, isComplete = param.isComplete, isFailedPaymentOrder = param.isFailedPaymentOrder, onBuyAgainClick = param.onBuyAgainClick, onCardClick = param.onCardClick;
    var renderStatus = function renderStatus() {
        if (order === null || order === void 0 ? void 0 : order.refund_info) {
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "refunded",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-items-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-text-13 tw-font-medium",
                                children: "Refunded"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "ref-id tw-mt-0.5 tw-text-12 tw-font-medium sm:tw-hidden",
                                children: [
                                    "ID:",
                                    (ref = order.refund_info) === null || ref === void 0 ? void 0 : ref.refund_id
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-mt-16 tw-flex tw-flex-col tw-items-end sm:tw-mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-text-13 tw-font-medium sm:tw-text-[#999]",
                                children: "Bank Reference ID"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ref-id tw-mt-0.5 tw-text-12 tw-font-medium",
                                children: (ref1 = order.refund_info) === null || ref1 === void 0 ? void 0 : ref1.bank_reference_number
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                getDisplayTextFromStatusText(order.display_status, order.pay_amount),
                order.prepaid_flag === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "f7 fw3 black-60 w-100 flex justify-end items-center pt1",
                    children: "Prepaid Online"
                })
            ]
        });
    };
    var ref, ref1, ref2;
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    }), theme = ref3.theme, services = ref3.services;
    var isServiceCustomizationEnabled = getOrderMode(order) !== constants/* STORE_CUSTOMIZATION.ORDER_BASED */.DO.ORDER_BASED && getOrderMode(order) !== constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B;
    var isB2bOrder = getOrderMode(order) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B;
    var getDisplayTextFromStatusText = function(statusText, amount) {
        switch(statusText){
            case "new":
                if ((0,getStoreType/* getStoreType */.K)() === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B) return "Request Raised";
                else if (isServiceCustomizationEnabled) return "Booking created";
                else return "Order Placed";
            case "billSent":
                return "Pay Now";
            case "rejected":
                return isServiceCustomizationEnabled ? "Booking Rejected" : "Order Rejected";
            case "sendBill":
            case "outForDelivery":
            case "markReady":
                return isB2bOrder ? "Request is being Reviewed" : isServiceCustomizationEnabled ? "Booking is being Reviewed" : "Order Seen";
            case "prepaidPickupReady":
                return isServiceCustomizationEnabled ? "Service Available" : "Ready For Pickup";
            case "prepaidDeliveryReady":
                return isServiceCustomizationEnabled ? "Service Available" : "Out For Delivery";
            case "completedOnline":
            case "completedCash":
            case "cashMarked":
            case "paidOnline":
                return "₹ ".concat(amount || 0);
            default:
                return "";
        }
    };
    var getOrderTypeLabel = function() {
        switch((0,getStoreType/* getStoreType */.K)()){
            case constants/* STORE_CUSTOMIZATION.ORDER_BASED */.DO.ORDER_BASED:
                return "Order ";
            case constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B:
                return "Request #";
            default:
                return "Booking ";
        }
    };
    var showWarning = order.display_status === "rejected" || isFailedPaymentOrder;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: classnames_default()("ds-order-item", isFailedPaymentOrder ? "!tw-cursor-default" : ""),
        onClick: onCardClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ds-order-item__head",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "top-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "oid",
                                children: [
                                    getOrderTypeLabel(),
                                    order.order_id
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "".concat(showWarning ? "warning" : "", " tl status"),
                                style: !showWarning ? {
                                    color: theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color
                                } : {},
                                children: isFailedPaymentOrder ? "Payment Failed" : renderStatus()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "time-wrap flexRowAlign",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: moment_default()(order.created_at).format("hh:mm a")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "flexRowAlign",
                                children: [
                                    order.display_status === "completedOnline" || order.display_status === "paidOnline" || order.display_status === "prepaidDeliveryCompleted" || order.display_status === "prepaidPickupCompleted" ? "Online Payment" : "",
                                    order.display_status === "completedCash" || order.display_status === "cashMarked" ? "Cash Payment" : ""
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ds-order-item__body",
                children: order.items && order.items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItem_ItemWithReview, {
                        order: order,
                        item: item,
                        isComplete: isComplete
                    }, index);
                })
            }),
            (services === null || services === void 0 ? void 0 : services.store_flag) !== 0 && isComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ds-order-item__footer",
                style: {
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "reorder-btn-wrap",
                    onClick: onBuyAgainClick,
                    style: {
                        color: theme === null || theme === void 0 ? void 0 : (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color,
                        borderColor: theme === null || theme === void 0 ? void 0 : (ref2 = theme.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color
                    },
                    children: "Buy Again"
                })
            })
        ]
    }, "order-items-".concat(order === null || order === void 0 ? void 0 : order.order_id));
};
/* harmony default export */ var components_OrderItem = (/*#__PURE__*/(0,react.memo)(OrderItem));

;// CONCATENATED MODULE: ./src/containers/Orders/components/RenderList.tsx











function RenderList() {
    var handleOrderItemClick = function handleOrderItemClick(orderItem) {
        if (activeTab === ORDERS_LIST_TYPE.FAILED_PAYMENTS) {
            return;
        }
        router.push((0,routes.getRoute)(routes.PATH.orderStatus(orderItem.order_hash), storeData.store_info.domain));
    };
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useContext)(context/* OrderContext */.y), activeTab = ref.activeTab, orders = ref.orders;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer.data,
            cart: state.cartReducer
        };
    }), userData = ref1.userData, cart = ref1.cart;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var shouldRenderList = Array.isArray(orders) && orders.length > 0;
    if (!shouldRenderList) return null;
    return orders.map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), date = _param[0], orders = _param[1];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "date-btn",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: date
                    })
                }),
                orders.map(function(orderItem, ind) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OrderItem, {
                        order: orderItem,
                        isComplete: activeTab === ORDERS_LIST_TYPE.COMPLETED,
                        isFailedPaymentOrder: activeTab === ORDERS_LIST_TYPE.FAILED_PAYMENTS,
                        onBuyAgainClick: function(e) {
                            return handleNavigateReorder(e, {
                                orderItems: orderItem.items,
                                cartItems: cart.items,
                                storeData: storeData,
                                userData: userData,
                                router: router
                            });
                        },
                        onCardClick: function() {
                            return handleOrderItemClick(orderItem);
                        }
                    }, "".concat(ind, "-order-item"));
                })
            ]
        }, "".concat(date, "-order-list-wrap"));
    });
}
/* harmony default export */ var components_RenderList = (RenderList);

;// CONCATENATED MODULE: ./src/containers/Orders/components/ListBody.tsx





function ListBody() {
    var ref = (0,react.useContext)(context/* OrderContext */.y), isLoading = ref.isLoading, loadMoreData = ref.loadMoreData, pagination = ref.pagination;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatList/* default */.Z, {
        isLoaderVisible: isLoading,
        isNext: pagination === null || pagination === void 0 ? void 0 : pagination.isNext,
        onScrollEnd: function() {
            return loadMoreData();
        },
        renderList: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RenderList, {});
        },
        renderInsideFragment: true
    });
}
/* harmony default export */ var components_ListBody = ((/* unused pure expression or super */ null && (ListBody)));

// EXTERNAL MODULE: ./src/redux/actions/order.js
var order = __webpack_require__(804160);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/globalLoader.tsx
var globalLoader = __webpack_require__(325480);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
;// CONCATENATED MODULE: ./src/containers/Orders/index.js
/**
 * Orders Page
 */ 




















var INITIAL_PAGINATION_CONFIG = {
    pageNum: 1,
    isNext: true
};
var Orders = function() {
    var resetActiveTabOrdersAndPagination = function resetActiveTabOrdersAndPagination() {
        setOrderList((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, orderList), (0,_define_property/* default */.Z)({}, activeTab, [])));
        setPagination((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pagination), (0,_define_property/* default */.Z)({}, activeTab, INITIAL_PAGINATION_CONFIG)));
    };
    var setActiveTabPagination = function setActiveTabPagination(data) {
        setPagination((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pagination), (0,_define_property/* default */.Z)({}, activeTab, (0,_object_spread/* default */.Z)({}, pagination[activeTab], data))));
    };
    var setActiveTabOrders = function setActiveTabOrders(data) {
        setOrderList((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, orderList), (0,_define_property/* default */.Z)({}, activeTab, (0,_to_consumable_array/* default */.Z)(orderList[activeTab]).concat((0,_to_consumable_array/* default */.Z)(data)))));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            userData: state.userReducer.data,
            storeId: (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : ref.store_id
        };
    }), userData = ref.userData, storeId = ref.storeId;
    var _obj;
    var ref1 = (0,react.useState)((_obj = {}, (0,_define_property/* default */.Z)(_obj, ORDERS_LIST_TYPE.COMPLETED, []), (0,_define_property/* default */.Z)(_obj, ORDERS_LIST_TYPE.PENDING, []), (0,_define_property/* default */.Z)(_obj, ORDERS_LIST_TYPE.FAILED_PAYMENTS, []), _obj)), orderList = ref1[0], setOrderList = ref1[1];
    var _obj1;
    var ref2 = (0,react.useState)((_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, ORDERS_LIST_TYPE.COMPLETED, INITIAL_PAGINATION_CONFIG), (0,_define_property/* default */.Z)(_obj1, ORDERS_LIST_TYPE.PENDING, INITIAL_PAGINATION_CONFIG), (0,_define_property/* default */.Z)(_obj1, ORDERS_LIST_TYPE.FAILED_PAYMENTS, INITIAL_PAGINATION_CONFIG), _obj1)), pagination = ref2[0], setPagination = ref2[1];
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react.useState)(ORDERS_LIST_TYPE.PENDING), activeTab = ref4[0], setActiveTab = ref4[1];
    (0,react.useEffect)(function() {
        var currPagination = pagination[activeTab];
        if (currPagination.pageNum === 1 && currPagination.isNext) {
            loadMoreData();
        }
    }, [
        activeTab,
        pagination
    ]);
    var loadMoreData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var authToken, payload;
            return (0,tslib_es6.__generator)(this, function(_state) {
                authToken = (0,getAuthToken/* getAuthToken */.b)();
                if (!pagination[activeTab].isNext || !authToken) {
                    return [
                        2
                    ];
                }
                setIsLoading(true);
                payload = {
                    phone: userData.phone || "",
                    storeid: storeId,
                    pageNum: pagination[activeTab].pageNum,
                    orderStatus: activeTab
                };
                if (!payload.phone) {
                    payload.userId = userData.user_id || "";
                }
                dispatch((0,order/* fetchOrderList */.z6)(payload, function(status) {
                    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    var _orders = data.orders, orders = _orders === void 0 ? [] : _orders, _isNextPage = data.isNextPage, isNextPage = _isNextPage === void 0 ? false : _isNextPage;
                    setIsLoading(false);
                    if (status) {
                        setActiveTabOrders(orders);
                        setActiveTabPagination({
                            pageNum: pagination[activeTab].pageNum + 1,
                            isNext: isNextPage
                        });
                    } else {
                        setActiveTabPagination({
                            isNext: false
                        });
                    }
                }));
                return [
                    2
                ];
            });
        });
        return function loadMoreData() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeActiveTab = function(tabType) {
        setActiveTab(tabType);
    };
    var contextValue = {
        activeTab: activeTab,
        onChangeActiveTab: onChangeActiveTab,
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        loadMoreData: loadMoreData,
        orders: orderList[activeTab],
        pagination: pagination[activeTab],
        resetActiveTabOrdersAndPagination: resetActiveTabOrdersAndPagination
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* OrderContext.Provider */.y.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "premium-order-list-screen",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "premium-order-list-wrapper !tw-pb-[40px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "premium-order-heading",
                            children: (0,getCustomCtaText/* default */.Z)("my_orders_cta")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderHeaderView, {}),
                        orderList[activeTab].length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListBody, {}) : !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoItemView, {}),
                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-flex tw-w-full tw-justify-center tw-pt-[20px] md:tw-pt-[40px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(globalLoader/* GlobalLoader */.k, {
                                type: "loader1",
                                color: (0,getThemeColor/* getThemeColor */.p)()
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticateUserModal, {})
            ]
        })
    });
};
/* harmony default export */ var containers_Orders = (/*#__PURE__*/(0,react.memo)(Orders));


/***/ }),

/***/ 317945:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reviewItemContainer":"ItemWithReview_reviewItemContainer__Ymwrk","gap":"ItemWithReview_gap__66YXB","verticalLine":"ItemWithReview_verticalLine__Sy2Fj","writeReview":"ItemWithReview_writeReview__wYrAh"};

/***/ })

}]);